import { render, staticRenderFns } from "./player-password-form.vue?vue&type=template&id=b189f508&"
import script from "./player-password-form.vue?vue&type=script&lang=js&"
export * from "./player-password-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports